// extracted by mini-css-extract-plugin
export default {"root":"py0pYe-W","wrapper":"OI86LcFZ","appear":"nFtoZ4ap"};